if (!customElements.get("compare-bar")) {
  class CompareBar extends HTMLElement {
    static OPEN_CLASS = "is-open";
    static EMPTY_CLASS = "is-empty";

    constructor() {
      super();

      this.total = 0;
      this.productData = [];

      this.mediaQuery = window.matchMedia("(max-width: 699px)");

      this.handleRemoveRef = this.handleRemove.bind(this);
    }

    removeProductByIndex(index) {
      if (index == -1) return;

      const deletedEntry = this.productData.splice(index, 1);
      deletedEntry[0].checkbox.checked = false;
    }

    handleRemove(event) {
      this.removeProductByIndex(
        this.productData.findIndex(
          (product) => product.handle == event.detail.handle
        )
      );
      this.updateProducts();
      this.updateTriggerInnerHTML();
    }

    handleClear(event) {
      event.preventDefault();

      this.productData.forEach((product) => (product.checkbox.checked = false));
      this.productData = [];

      localStorage.removeItem(window.location.pathname);

      this.updateProducts();
      this.updateTriggerInnerHTML();
      this.handleClose();
    }

    handleOpen() {
      this.classList.add(CompareBar.OPEN_CLASS);

      this.updateTriggerInnerHTML();
    }

    handleClose() {
      this.classList.remove(CompareBar.OPEN_CLASS);
    }

    handleMediaChange() {
      this.updateTotal();
    }

    handleAddProductsToCache() {
      localStorage.setItem(
        window.location.pathname,
        JSON.stringify(this.productData)
      );
    }

    handleLoadProductsFromCache() {
      const data = JSON.parse(
        localStorage.getItem(window.location.pathname)
      );
      if (!data || !data.length) return;

      this.productData = data;
      this.updateProducts(true);
      this.handleOpen();
    }

    handleRemoveFirstElement() {
      if (this.productData.length > this.total) {
        const removedElement = this.productData.shift();
        removedElement.checkbox.checked = false;

        this.handleAddProductsToCache();
      }
    }

    handleCheckboxChange(event) {
      if (!event.target.hasAttribute("js-compare-checkbox")) return;
      if (this.productData.length == this.total && event.target.checked) {
        event.target.checked = false;
        return event.preventDefault();
      }

      const handle = event.target.getAttribute("data-product-handle");
      const imageUrl = event.target.getAttribute("data-image-url");

      if (event.target.checked) {
        this.productData.push({ handle, imageUrl, checkbox: event.target });
      } else {
        this.removeProductByIndex(
          this.productData.findIndex((item) => item.handle == handle)
        );
      }

      this.handleRemoveFirstElement();

      this.updateProducts();
      this.handleOpen();
    }

    handleClick(event) {
      const target = event.target.closest("[js-remove-id]");
      if (!target) return;

      event.preventDefault();

      const targetId = target.getAttribute('js-remove-id');
      if(!targetId) return;

      const index = Array.from(this.productElements).findIndex(product => product.getAttribute('data-id') == targetId);
      if(!this.productData[index]) return;

      this.productData[index].checkbox.click();
    }

    updateTotal() {
      this.total = Number(
        this.mediaQuery.matches
          ? this.triggerButton.getAttribute("js-max-count-mobile")
          : this.triggerButton.getAttribute("js-max-count-desktop")
      );

      this.updateTriggerInnerHTML();
      this.handleRemoveFirstElement();
    }

    updateTriggerInnerHTML() {
      if (this.mediaQuery.matches) {
        this.triggerButton.innerHTML = this.triggerButton.getAttribute(
          "data-template-mobile"
        );
      } else {
        this.triggerButton.innerHTML = this.triggerButton
          .getAttribute("data-template")
          .replace("[[current]]", this.productData.length)
          .replace("[[total]]", this.total);
      }

      this.triggerButton.toggleAttribute('disabled', this.productData.length <= 1);
    }

    updateProductHTML(element, index) {
      element.classList.toggle("is-empty", !this.productData[index]);

      const image = element.querySelector("img");
      if (!this.productData[index]) return (image.src = "");

      image.src = this.productData[index].imageUrl;
    }

    updateProducts(fromCache = false) {
      if (!this.productData.length) {
        localStorage.removeItem(window.location.pathname);

        requestAnimationFrame(() => {
          this.handleClose();
        });
      }

      this.productElements.forEach((element, index) => {
        this.updateProductHTML(element, index);
      });

      if (fromCache) {
        this.productData.forEach((product) => {
          const checkbox = document.querySelector(
            `[data-product-handle="${product.handle}"]`
          );
          if (!checkbox) return;

          checkbox.checked = true;
          product.checkbox = checkbox;
        });

        return;
      }

      this.handleAddProductsToCache();
    }

    loadCompareTable(event) {
      event.preventDefault();

      const compareUrl = new URL(window.location.href);

      compareUrl.searchParams.set(
        "compare-products",
        this.productData
          .map((product) => product.handle)
          .join("--")
          .concat("END_COMPARE")
      );

      if (
        this.compareUrl &&
        this.compareUrl.toString() == compareUrl.toString()
      ) {
        return document.dispatchEvent(new CustomEvent("compare-table:toggle"));
      }

      fetch(compareUrl)
        .then((res) => res.text())
        .then((text) => {
          if (!text) throw new Error("Compare table section not found");

          const html = new DOMParser().parseFromString(text, "text/html");

          const newCompareTable = html.querySelector("[js-compare-table]");

          document.dispatchEvent(
            new CustomEvent("compare-table:update", {
              detail: { html: newCompareTable.innerHTML },
            })
          );

          this.compareUrl = compareUrl;
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {
      document.removeEventListener("compare-bar:remove", this.handleRemoveRef);
    }

    connectedCallback() {
      this.clearButton = this.querySelector("[js-clear]");
      this.triggerButton = this.querySelector("[js-trigger]");
      this.productElements = this.querySelectorAll("[js-compare-product]");

      if (this.clearButton) {
        this.clearButton.addEventListener("click", this.handleClear.bind(this));
      } else {
        console.error("Missing clear button from CompareBar");
      }

      if (this.triggerButton) {
        this.triggerButton.addEventListener(
          "click",
          this.loadCompareTable.bind(this)
        );
      } else {
        console.error("Missing trigger button from CompareBar");
      }

      document.addEventListener("compare-bar:remove", this.handleRemoveRef);
      document.addEventListener("change", this.handleCheckboxChange.bind(this));

      this.addEventListener("click", this.handleClick.bind(this));

      this.mediaQuery.addEventListener(
        "change",
        this.handleMediaChange.bind(this)
      );

      this.handleLoadProductsFromCache();

      this.updateTotal();
    }
  }

  customElements.define("compare-bar", CompareBar);
}
